<template>
  <div>
    <template v-if="isAdmin">
      <a-layout>
        <a-layout-header>
          <header-action></header-action>
        </a-layout-header>
        <a-layout-content>
          <content-list></content-list>
        </a-layout-content>
      </a-layout>
    </template>

    <template v-else>
      <a-result status="403" title="403" sub-title="抱歉, 您没有权限访问该页面">
        <template #extra>
          <a-button type="primary" @click="goHome"> 返回首页 </a-button>
        </template>
      </a-result>
    </template>
  </div>
</template>

<script>
import HeaderAction from "@/views/message-center/components/HeaderAction";
import ContentList from "@/views/message-center/components/ContentList";

export default {
  components: { HeaderAction, ContentList },
  data() {
    return {
      isAdmin: false,
      adminCodes: "MaYA8n0nodrYnQWRo1bPsqDlEmmw9CrCxppYYeTZ4okuaoCistVY",
    };
  },
  created() {
    const { admin_daqiang } = this.$route.query;

    if (!admin_daqiang) {
      this.isAdmin = false;
      // this.$router.push('/home')
      return;
    }

    if (admin_daqiang && admin_daqiang === this.adminCodes) {
      this.isAdmin = true;
      return;
    }
  },
  methods:{
    goHome(){
      this.$router.push('/home')
    }
  }
};
</script>

<style lang="less" scoped>
.empty {
  height: 100vh;
  background-color: #f0f2f5;
  font-size: 72px;
  font-weight: bold;
}
.ant-layout {
  .ant-layout-header {
    // height: 120px;
    background: #001529;
    color: #000;
  }
  .ant-layout-content {
    height: calc(100vh - 65px);
    padding: 24px;
  }
}
</style>